export const ALLOWED_CHARS_PATTERN = "^[a-zA-Z\u0590-\u05FF0-9@()'.,\\[\\]{}\\\":+\\/=\\-–— \\\\?_\n]*$";
